"use strict";

exports.__esModule = true;
exports.default = void 0;
var _emotion = require("emotion");
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _reactEmotion = _interopRequireWildcard(require("react-emotion"));
var _chevronRight = _interopRequireDefault(require("react-feather/dist/icons/chevron-right"));
var _base = _interopRequireDefault(require("../../shared/base"));
var _font = _interopRequireDefault(require("../../shared/font"));
var _utils = require("../../shared/utils");
var _mediaQueries = _interopRequireDefault(require("../../shared/mediaQueries"));
var _css2;
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var label = function label(props) {
  var _css;
  return /*#__PURE__*/(
    (0, _reactEmotion.css)((_css = {
      background: (0, _utils.getProperty)(props, 'accentColor'),
      padding: '2px 12px',
      borderRadius: 12.5,
      fontSize: '0.8rem',
      margin: '0 3px'
    }, _css[(0, _mediaQueries.default)('md')] = {
      height: 10,
      width: 10,
      borderRadius: '50%',
      fontSize: 0,
      padding: 0,
      margin: '0 15px'
    }, _css[(0, _mediaQueries.default)('xs')] = {
      margin: '0 10px'
    }, _css))
  );
};
var container = /*#__PURE__*/
(0, _reactEmotion.css)((_css2 = {
  display: 'grid',
  gridTemplateColumns: 'auto auto auto',
  alignItems: 'center',
  justifyItems: 'center',
  gridGap: 0,
  maxWidth: 550,
  background: 'rgba(255, 255, 255, 0.5)',
  padding: '5px 0',
  borderRadius: 15
}, _css2[(0, _mediaQueries.default)('md')] = {
  gridTemplateColumns: 'auto 1fr auto',
  padding: '10px 0',
  maxWidth: '100%',
  borderRadius: 0
}, _css2));
var Link = /*#__PURE__*/
(0, _reactEmotion.default)('a', {
  target: "e6ihpr20"
})(function (_ref) {
  var _ref2;
  var theme = _ref.theme;
  return _ref2 = {
    fontSize: '0.9rem',
    fontWeight: 400,
    textDecoration: 'none',
    color: theme.primaryColor,
    '&:hover': {
      textDecoration: 'underline',
      textDecorationSkipInk: 'auto'
    }
  }, _ref2[(0, _mediaQueries.default)('md')] = {
    justifySelf: 'start'
  }, _ref2;
});
var Label = /*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "e6ihpr21"
})(label);
var Container = /*#__PURE__*/
(0, _reactEmotion.default)("section", {
  target: "e6ihpr22"
})(_base.default, _font.default, container);
var News = function News(_ref3) {
  var children = _ref3.children,
    className = _ref3.className,
    style = _ref3.style,
    href = _ref3.href,
    target = _ref3.target;
  return _react.default.createElement(Container, {
    className: className,
    style: style
  }, _react.default.createElement(Label, null, "NEW"), _react.default.createElement(Link, {
    href: href,
    target: target
  }, children), _react.default.createElement(_chevronRight.default, {
    className: (0, _emotion.css)({
      margin: '0 10px 0 0',
      height: '0.9rem'
    })
  }));
};
News.propTypes = {
  children: _propTypes.node,
  className: _propTypes.string,
  href: _propTypes.string,
  target: _propTypes.string,
  style: _propTypes.object
};
var _default = News;
exports.default = _default;